import React, { ChangeEvent, ReactNode, useCallback } from "react";

import InputText from "@/components/atoms/inputForms/InputText";
import Label from "@/components/atoms/inputForms/Label2";
import { Button } from "@/components/atoms/buttons/Button";
import { Address, ZipcodeResult, addressSearch } from "@/pages/api/zipcode";

interface Props {
  id?: string;
  idFirst?: string;
  nameFirst?: string;
  valueFirst?: string;
  onChangeFirst: (ev: ChangeEvent<HTMLInputElement>) => void;
  onSetZipAddress: (prefectureId: string | undefined, address: string) => void;
  errors?: string[];
  placeholderFirst?: string;
  label?: string;
  isLabelBorder?: boolean;
  isRequired?: boolean;
  description?: string;
}

export default function InputSearchZipField({
  id,
  idFirst,
  nameFirst,
  valueFirst,
  onChangeFirst,
  errors,
  placeholderFirst,
  label,
  isLabelBorder,
  isRequired,
  description,
  onSetZipAddress,
}: Props) {
  const hasError = errors && errors.length > 0;

  const handleFetchZip = useCallback(async () => {
    const zip = valueFirst ?? "";

    if (!zip) return;

    const res: ZipcodeResult = await addressSearch(zip);
    if (res.results) {
      const result: Address = res.results[0];
      if (result) {
        const addressText = result.address2 || "" + result.address3 || "";
        onSetZipAddress(result?.prefcode || "", addressText);
      }
    } else {
      onSetZipAddress(undefined, "");
    }
  }, [valueFirst, onSetZipAddress]);

  const wrap = (children: ReactNode) =>
    label ? (
      <>
        <Label
          label={label}
          spBorder={isLabelBorder}
          htmlFor={id && `${id}1`}
          id={id && `label-${id}`}
          isRequired={isRequired}
          description={description}
        />
        {children}
      </>
    ) : (
      <>{children}</>
    );

  return wrap(
    <div id={id}>
      <div className="flex items-center space-x-2">
        <div className="w-[150px]">
          <InputText
            id={idFirst}
            name={nameFirst}
            onChange={onChangeFirst}
            value={valueFirst}
            hasError={hasError}
            placeholder={placeholderFirst}
            ariaLabelledby={id && `label-${id}`}
            inputMode="numeric"
          />
        </div>
        <Button
          type="button"
          color="primary-outline"
          label="住所を自動入力"
          className="!min-w-[146px] !h-11 ml-2"
          onClick={handleFetchZip}
        />
      </div>
    </div>,
  );
}
